import { useCallback as u, useMemo as a } from "react";
import { C as d } from "../../utils-wNl4DVdv.js";
import { MetricGrowthType as l, GenericChartTypes as r, ChartFormat as p } from "../../configuration/types.js";
const h = () => u((e, n, s, o) => ({
  extraConf: {
    ...n.extraConf,
    isDisplayedOnSecondaryAxis: d(e, n, s, o)
  },
  extraConfDefaultProperties: {
    isDisplayedOnSecondaryAxis: !0
  }
}), []), B = () => u((e, n, s, o) => {
  var t, i, x, A;
  if (((t = n.extraConf) == null ? void 0 : t.isDisplayedOnSecondaryAxis) === ((i = s[e].extraConf) == null ? void 0 : i.isDisplayedOnSecondaryAxis)) {
    const f = d(e, n, s, o), c = !!((x = n.extraConfDefaultProperties) != null && x.isDisplayedOnSecondaryAxis), C = c ? f : (A = n.extraConf) == null ? void 0 : A.isDisplayedOnSecondaryAxis;
    return {
      extraConf: {
        ...n.extraConf,
        isDisplayedOnSecondaryAxis: C
      },
      extraConfDefaultProperties: {
        isDisplayedOnSecondaryAxis: c
      }
    };
  } else
    return {
      extraConf: n.extraConf,
      extraConfDefaultProperties: {
        isDisplayedOnSecondaryAxis: !1
      }
    };
}, []), w = (e) => a(() => {
  switch (e) {
    case r.TABLES:
      return l.RATIO;
    default:
      return l.VALUE;
  }
}, [e]), E = (e, n) => a(() => !!(e && ([r.LINE].includes(e) || e === r.BARS && n === p.V_GROUPED)), [e, n]), G = (e, n, s = void 0, o = 0) => a(
  () => e === "compact" ? {
    flex: n
  } : {
    span: s,
    offset: o
  },
  [n, o, s, e]
);
export {
  h as useAddSecondaryAxisOption,
  G as useColumnLayout,
  w as useDefaultGrowth,
  E as useIsAxisOptionAllowed,
  B as useModifiedSecondaryAxisOption
};
//# sourceMappingURL=hooks.js.map
